import AIInfoTooltip from '@/components/LyearnAI/components/AIInfoTooltip';

import { useAIEditorContext } from '../../../../context/AIEditorContext';

const AI_INFO_TOOLTIP_CLASSES = {
  root: 'p-4',
  icon: 'w-20 h-20',
};

const AIDisclaimerTool: React.FC = () => {
  const { isAIActive } = useAIEditorContext();

  return isAIActive ? <AIInfoTooltip classes={AI_INFO_TOOLTIP_CLASSES} placement="bottom" /> : null;
};

export default AIDisclaimerTool;
